import { useSegmentsSelectInputQuery } from "@/graphql/generated-types";
import { computed } from "vue";

export function useSegments(gameId: string) {
  const { result } = useSegmentsSelectInputQuery({
    gameId,
    versionId: "wip", // we will always fetch the wip segments
  });
  const segments = computed(() => (result.value?.game?.version?.segments || []).map(({ id, name }) => ({ name, id })));

  return {
    segments,
  };
}
